import type { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';

import { useGetUserProfile } from '@/api/user-dashboard/queries';
import { PagePaths } from '@/routes/page-paths';
import { Spinner } from '@/shared/design-system';

import { isSignUpPageHeld } from '../sign-up-page-hold';
import { GateViewport } from './cognito-session-gate.styled';

export const CognitoSessionGate = ({ children }: { children: ReactNode }) => {
  const { isPending } = useGetUserProfile();
  const { pathname } = useLocation();
  // Password recovery logs in mid-flow and reloads the profile; the gate would unmount the page and
  // drop its step state.
  const keepsPage =
    pathname === PagePaths.forgotPassword || (pathname === PagePaths.signUp && isSignUpPageHeld());
  if (isPending && !keepsPage) {
    return (
      <GateViewport role="status" aria-label="Checking your session">
        <Spinner />
      </GateViewport>
    );
  }
  return children;
};
